<!-- 场馆漫游 -->
<template>
    <div class="listcontainer">
        <slot></slot>        
        <div :class="isMobile?'mlayout':'layout'" v-if="isMobile">
            <div class="header">
                <span class="title">倾斜摄影</span>
            </div>
           <div class="scenesC">
                <Swiper :options="swiperOption2">
                    <SwiperSlide v-for="(item,i) in scenes" :key="i" class="swiper-slide">
                        <div :class="['bg',i==mcur?'active':'']">
                            <img v-if="i==mcur" :src="item.imghover" alt="" @click="toGis(item)">
                            <img v-else :src="item.img" alt="" @click="toGis(item)">
                        </div>            
                    </SwiperSlide>
                </Swiper>
               
           </div>                     
        </div>
        <div :class="isMobile?'mlayout':'layout'" v-else>
            <div class="header">
                <span class="title">倾斜摄影</span>
            </div>
           <div class="scenesC">                
                    <div v-for="(item,i) in scenes" :key="i" class="swiper-slide">
                        <div :class="['bg',i==cur?'active':'']" @mouseover="showActive(i)" @mouseleave="hideActive">
                            <img v-if="i==hoverIndex" :src="item.imghover" alt="" @click="toGis(item)">
                            <img v-else :src="item.img" alt="" @click="toGis(item)">
                        </div>            
                    </div>                              
           </div>                     
        </div>
       
       
    </div>

</template>

<script>
    //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
    //例如：import 《组件名称》 from '《组件路径》';
    import browser from '@/utils/browser.js'
    import {
        Swiper,
        SwiperSlide
    } from "vue-awesome-swiper";
    import "swiper/css/swiper.css";
    export default {
        //import引入的组件需要注入到对象中才能使用
        components: {
            Swiper,
            SwiperSlide,
        },
        data() {
            //这里存放数据
            return {
                isMobile: browser.mobile,
                cur: 3,
                mcur:0,
                hoverIndex:-1,
                QXs:[
                    '',
                    '',
                    '',
                    ''
                ],
                scenes: [
                    {
                        name: '红井',
                        id:1,
                        intro: '',
                        pano: 1,
                        img: require('../../assets/images/gis1.png'),
                        imghover: require('../../assets/images/gis1_on.png'),
                        

                    },{
                        name: '瑞金纪念馆',
                        id:2,
                        intro: '',
                        pano: 2,
                        img: require('../../assets/images/gis2.png'),
                        imghover: require('../../assets/images/gis2_on.png'),

                    },{
                        id:3,
                        name: '叶坪红色旅游景区',
                        intro: '',
                        pano: 3,
                        img: require('../../assets/images/gis3.png'),
                        imghover: require('../../assets/images/gis3_on.png'),

                    },{
                        name: '洋溪村',
                        id:4,
                        intro: '',
                        pano: 4,
                        img: require('../../assets/images/gis4.png'),
                        imghover: require('../../assets/images/gis4_on.png'),

                    }
                ]
            };
        },
        //监听属性 类似于data概念
        computed: {
            swiperOption2() {
                 var _this = this;
                return {
                    pagination: {
                        el: ".pagination",
                        type: "bullets",
                        clickable: true
                    },
                    effect: "coverflow",
                    slidesPerView: 3,
                    centeredSlides: true,
                    coverflowEffect: {
                    rotate: 30,
                    stretch: 0,
                    depth: 150,
                    modifier: 2,
                    slideShadows: false,
                    },
                    // freeMode:true,
                    // normalizeSlideIndex: true,
                    // slideActiveClass : 'slide-active',
                    on: {
                        slideChange: function () {
                            console.log(this.activeIndex);
                             _this.mcur = this.activeIndex;
                        }
                    },

                };
            },
        },
        //监控data中的数据变化
        watch: {},
        //方法集合
        methods: {
            showActive(i) {
                this.hoverIndex = i;
            },
            hideActive() {
                this.hoverIndex = -1;
            },
            goScene(id) {
                this.$router.push({
                    name: 'Scene',
                    query: {
                        id: id
                    }
                })
            },
            showScene(id, i) {
                if (i == this.cur) {
                    this.$router.push({
                        name: 'Scene',
                        query: {
                            id: id
                        }
                    })
                }
                this.cur = i;

            },
            toGis(item) {
                this.$router.push({name:'Gis',query:{id:item.pano}});
                this.$emit('closeGis')
            }
        },
        //生命周期 - 创建完成（可以访问当前this实例）
        created() {

        },
        //生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {

        },
        beforeCreate() {}, //生命周期 - 创建之前
        beforeMount() {}, //生命周期 - 挂载之前
        beforeUpdate() {}, //生命周期 - 更新之前
        updated() {}, //生命周期 - 更新之后
        beforeDestroy() {}, //生命周期 - 销毁之前
        destroyed() {}, //生命周期 - 销毁完成
        activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
    //@import url(); 引入公共css类
    .listcontainer {
        width: 100%;
        height: 100%;
    }
    .layout {
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-size: cover;

        .header {
            width: 100%;
            height: 8.33vw;
            margin-bottom: 6.77vw;
            text-align:center;

            .title {
                font-size: 24px;
                color: #fff;
                line-height: 8.33vw;
                border-bottom:2px dashed #fff;
                padding-bottom:10px;
                
            }
        }
      
        .scenesC {
            width:90%;
            margin:0 auto;
            display:flex;
            justify-content: center;
            .btn {
                border:none;
                outline:none;
                position:absolute;
                display:block;
                width:2.9vw;
                height:2.9vw;
                top:0;
                bottom:0;
                margin:auto;
                 &.left {               
                    left:1vw;                
                }
                &.right {               
                    right:1vw;                
                }
            }
           
        }
        .swiper-slide {
            cursor:pointer;
            .hover-info {
                position: absolute;
                top: 100%;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(152, 2, 4, 0.75);
                padding-top: 14vh;
                transition: all 1.5s;
                .name {
                    width: 18.75vw;
                    height: 4.6875vw;
                    margin: 0 auto;
                    border: 2px solid #ffde00;
                    color: #ffde00;
                    font-size: 3vw;
                    font-weight: bold;
                    text-align: center;
                    line-height: 4.6875vw;
                    border-radius: 0.5vw;
                }
                p {
                    font-size: 1.25vw;
                    line-height: 2vw;
                    color: #ffde00;
                    padding: 0 1vw;
                    text-indent: 2em;
                    margin-top: 10vh;
                    text-align: justify;
                }
            }
            &:hover {
                .hover-info {
                    top: 0;
                }
            }
        }

        
         .swiper-slide {
            width:16.77vw;
            height:25.1vw;
        .bg {
            position:relative;
            text-align:center;
            transform:scale(0.9);
            transition:all 0.5s ease;
           
            &:hover {
                 transform:scale(1);
            }
           
            img {
                width:98%;
            }
            
            
        }
    }
    }
    .mlayout {
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-size: cover;
        .header {
            width: 100%;
            height: 21.3vw;
            margin-bottom: 0;
            text-align:center;
            .title {
                font-size: 24px;
                color: #fff;
                line-height: 21.3vw;
                text-align: center;
                border-bottom:2px dashed #fff;
            }
        }
        .scenesC {
            width:98%;
            margin:0 auto;
        }
        .swiper-slide {
            width: 93vw;
            height: 120vw;
            max-height: 400px;
            display: flex;
            justify-content: center;
            align-content: center;
            cursor:pointer;
            .bg {
                img {
                    max-width:267px;
                    max-height:400px;
                    width: 71vw;
                    height: 106vw;
                }
            }
            
            .hover-info {
                position: absolute;
                top: 100%;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(152, 2, 4, 0.75);
                padding-top: 14vh;
                transition: all 1.5s;

                .name {
                    width: 18.75vw;
                    height: 4.6875vw;
                    margin: 0 auto;
                    border: 2px solid #ffde00;
                    color: #ffde00;
                    font-size: 3vw;
                    font-weight: bold;
                    text-align: center;
                    line-height: 4.6875vw;
                    border-radius: 0.5vw;
                }

                p {
                    font-size: 1.25vw;
                    line-height: 2vw;
                    color: #ffde00;
                    padding: 0 1vw;
                    text-indent: 2em;
                    margin-top: 10vh;
                    text-align: justify;
                }
            }

            &:hover {
                .hover-info {
                    top: 0;
                }
            }
        }

        .prev {
            position: absolute;
            z-index: 2;
            width: 2vw;
            height: 2vw;
            left: 1.56vw;
            top: 0;
            bottom: 0;
            margin: auto;
            outline: none;
            border: none;

            img {
                width: 100%;
            }
        }

        .next {
            position: absolute;
            z-index: 2;
            width: 2vw;
            height: 2vw;
            right: 1.56vw;
            top: 0;
            bottom: 0;
            margin: auto;
            outline: none;
            border: none;

            img {
                width: 100%;
            }
        }
    }

    

   

    .mlayout .swiper-slide {
        width: 90vw;
    }

    .pagination {
        text-align: center;
    }

    .mlayout .pagination {
        height: 2px;
        font-size: 0;
    }
</style>
<style>
    .pagination .swiper-pagination-bullet {
        width: 2vw;
        height: 2px;
        background: #b52223;
        margin: 0 5px;
    }
</style>